import type { TefComs4p } from '@mfe/components/TefComs4p';
import { componentStateStore } from '@mfe/store';
import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

//
// renders the main component view in either EDIT or VIEW mode
//
export const tefComs4pEdit = function render(this: TefComs4p) {
  const buttonClasses = {
    button: true, 'button-tag--prio-tertiary': true, 'button-tag': true, 'button-tag--state-disabled': componentStateStore.disabled,
  };

  return html`
    <div class="container" data-testid="root">
      <section cloak=${this.cloak || nothing}>
        <h4 class="typography-display--4">Partner-APP Einstellungen</h4>
        <p>
          Im Folgenden können Sie die Einstellungen Ihrer Partner-APP für Ihre Rufnummern einsehen und ändern.   
        </p>
        ${this.getTemplateFn('singlePurposeEdit')(componentStateStore.activePurpose)}
        <section class="section section-buttons">
          <div class="form-row form-row--buttons">
            <tef-coms-cancel-button text="Abbrechen"></tef-coms-cancel-button>
            <button class=${classMap(buttonClasses)} @click=${this.saveConsentsForActivePurpose}>Speichern</button>
          </div>        
        </section>
      </section>
    </div>
    `;
};
